<template>
  <div class="alipay-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-wrapper">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/Welcome' }">
          <i class="el-icon-s-home"></i> 首页
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <i class="el-icon-truck"></i> 汽车编辑
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 卡片内容 -->
    <el-card class="alipay-card" shadow="never">
      <div slot="header" class="card-header">
        <span>{{ ruleForm.id ? '编辑车辆' : '新增车辆' }}</span>
      </div>

      <el-form
        :inline="false"
        :model="ruleForm"
        :rules="rules"
        ref="formForRef"
        label-width="100px"
        label-position="right"
        size="small"
        class="alipay-form"
      >
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="标题" prop="title">
              <el-input v-model="ruleForm.title" placeholder="请输入标题" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="车系" prop="style_id">
              <el-select v-model="ruleForm.style_id" placeholder="请选择车系" clearable filterable>
                <el-option v-for="item in cateMenus" :key="item.id" :label="item.pid > 0 ? '|--' + item.name : item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="年份">
              <el-select v-model="ruleForm.year_id" filterable clearable placeholder="请选择年份">
                <el-option v-for="item in carYearList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="孔距">
              <el-select v-model="ruleForm.pitch_id" placeholder="请选择孔距" clearable filterable>
                <el-option v-for="item in pitchMenus" :key="item.id" :label="item.pid > 0 ? '|--' + item.name : item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="中心孔">
              <el-input v-model="ruleForm.center_bore" placeholder="请输入中心孔" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="ET">
              <el-input v-model="ruleForm.et" placeholder="请输入ET" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="原车尺寸">
              <el-input v-model="ruleForm.dimensions" placeholder="请输入原车尺寸" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="排序">
              <el-input-number v-model="ruleForm.sort" :min="0" :max="9999" controls-position="right" style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="推荐">
              <el-switch v-model="ruleForm.is_recommend" active-text="推荐" inactive-text="普通"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="车辆图片">
              <div class="image-uploader">
                <div v-if="ruleForm.file_url" class="image-preview" @click="showImgDoc(1)">
                  <el-image :src="ruleForm.file_url" fit="cover" :preview-src-list="[ruleForm.file_url]"></el-image>
                  <div class="image-mask" @click.stop="ruleForm.file_url = ''">
                    <i class="el-icon-delete"></i>
                  </div>
                </div>
                <div v-else class="upload-trigger" @click="showImgDoc(1)">
                  <i class="el-icon-plus"></i>
                  <span>点击选择图片</span>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 富文本编辑器（已注释，保留原功能） -->
        <!-- 如果启用富文本编辑器，可在此处添加样式 -->

        <el-form-item class="form-actions">
          <el-button type="primary" @click="submitForm" :loading="isSubmitting">保 存</el-button>
          <el-button @click="resetForm('formForRef')">重 置</el-button>
          <el-button @click="goBack">返 回</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 商家选择弹窗（保留） -->
    <eShop :formData="formData" :visible.sync="visible" :title="title" :closeForm="closeForm" />

    <!-- 图片素材选择弹窗 -->
    <eDocList :formData="formData1" :visible.sync="visible1" :title="title1" :closeForm="closeForm1" v-on:eventChoose="eChooseDoc" />
  </div>
</template>

<script>
import eDocList from "../common/eDocList";
import eShop from "../common/eShopList";
// import CryptoJS from "crypto-js";
// import axios from 'axios';

export default {
  components: { eShop, eDocList },
  data() {
    return {
      isSubmitting: false,
      carYearList: [],
      formData: {},
      title: '',
      visible: false,
      formData1: {},
      title1: '',
      visible1: false,
      type_img: 1,
      fileList: [],
      ruleForm: {
        year_id: '',
        url: '',
        shop_name: '',
        shop_id: '',
        id: '',
        title: '',
        ad_link: '',
        style_id: '',
        pitch_id: '',
        file_url: '',
        content: '',
        is_recommend: false,
        sort: 1,
        center_bore: '',
        et: '',
        dimensions: ''
      },
      addForm: { start_time: "", province_id: '', city_id: '', district_id: '' },
      cateMenus: [],
      pitchMenus: [],
      rules: {
        title: [{ required: true, message: "请输入标题", trigger: 'blur' }],
        style_id: [{ required: true, message: "请选择车系", trigger: 'change' }]
      }
    };
  },
  mounted() {
    this.getCarStyleTree();
    this.getPitchTree();
    this.getCarYeaList();
    this.ruleForm.id = this.$route.query.id;
    if (!isNaN(this.ruleForm.id) && this.ruleForm.id > 0) {
      this.getOne();
    }
  },
  methods: {
    getCarYeaList() {
      this.$axios.findCarYearList({ access_token: sessionStorage.getItem('token'), company_id: sessionStorage.getItem('company_id') })
        .then(res => { if (res.code == 200) this.carYearList = res.data; });
    },
    eChooseDoc(id, name,url) {
      console.log('eChooseDoc',name)
        console.log(url)
      if (this.type_img == 1) this.ruleForm.file_url = url;
    },
    showImgDoc(type) {
      this.type_img = type;
      this.title1 = "图片选择";
      this.visible1 = true;
    },
    closeForm1() { this.visible1 = false; },
    closeForm() { this.visible = false; },
    chooseM() { this.title = '选择商家'; this.visible = true; },
    submitForm() {
      this.$refs.formForRef.validate(valid => {
        if (!valid) return;
        this.isSubmitting = true;
        const params = {
          access_token: sessionStorage.getItem('token'),
          company_id: sessionStorage.getItem('company_id'),
          id: this.ruleForm.id,
          center_bore: this.ruleForm.center_bore,
          dimensions: this.ruleForm.dimensions,
          et: this.ruleForm.et,
          title: this.ruleForm.title,
          style_id: this.ruleForm.style_id,
          pitch_id: this.ruleForm.pitch_id,
          file_url: this.ruleForm.file_url,
          content: this.ruleForm.content,
          is_recommend: this.ruleForm.is_recommend ? 1 : 0,
          sort: this.ruleForm.sort
        };
        if (!isNaN(this.ruleForm.year_id)) params.year_id = this.ruleForm.year_id;
        this.$axios.carinfoSaveOne(params).then(res => {
          if (res.code == 200) {
            this.$message.success('保存成功');
            setTimeout(() => this.$router.replace('/carList'), 800);
          } else {
            this.$message.error(res.msg || '保存失败');
          }
        }).catch(() => this.$message.error('保存失败')).finally(() => { this.isSubmitting = false; });
      });
    },
    getOne() {
      this.$axios.findCarOne({ access_token: sessionStorage.getItem('token'), company_id: sessionStorage.getItem('company_id'), id: this.ruleForm.id })
        .then(res => {
          if (res.code == 200) {
            const item = res.data;
            this.ruleForm.title = item.title;
            this.ruleForm.style_id = item.style_id;
            this.ruleForm.pitch_id = item.pitch_id;
            this.ruleForm.id = item.id;
            this.ruleForm.year_id = item.year_id;
            this.ruleForm.file_url = item.file_url;
            this.ruleForm.sort = item.sort;
            this.ruleForm.center_bore = item.center_bore;
            this.ruleForm.dimensions = item.dimensions;
            this.ruleForm.et = item.et;
            this.ruleForm.is_recommend = item.is_recommend == 1;
          }
        });
    },
    resetForm(formName) { this.$refs[formName].resetFields(); },
    goBack() { this.$router.go(-1); },
    getCarStyleTree() {
      this.$axios.findCarStyleTable({ access_token: sessionStorage.getItem('token'), company_id: sessionStorage.getItem('company_id') })
        .then(res => { if (res.code == 200) this.cateMenus = res.data; });
    },
    getPitchTree() {
      this.$axios.findPitchTable({ access_token: sessionStorage.getItem('token'), company_id: sessionStorage.getItem('company_id') })
        .then(res => { if (res.code == 200) this.pitchMenus = res.data; });
    }
  }
};
</script>

<style lang="scss" scoped>
.alipay-container {
  padding: 16px 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

.breadcrumb-wrapper {
  margin-bottom: 16px;
  .el-breadcrumb {
    font-size: 14px;
    i { margin-right: 4px; }
  }
}

.alipay-card {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  &:hover {
    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.08);
  }
  ::v-deep .el-card__header {
    background: #fafbfc;
    border-bottom: 1px solid #f0f2f6;
    padding: 16px 20px;
    .card-header {
      font-size: 16px;
      font-weight: 600;
      color: #1f2d3d;
    }
  }
  ::v-deep .el-card__body {
    padding: 24px;
  }
}

.alipay-form {
  ::v-deep .el-form-item__label {
    font-size: 13px;
    font-weight: 500;
    color: #5a6874;
  }
  ::v-deep .el-input__inner,
  ::v-deep .el-select .el-input__inner,
  ::v-deep .el-input-number .el-input__inner {
    border-radius: 20px;
    border-color: #dcdfe6;
    transition: all 0.2s;
    &:focus {
      border-color: #1677ff;
      box-shadow: 0 0 0 2px rgba(22, 119, 255, 0.1);
    }
  }
  ::v-deep .el-input-number.is-controls-right .el-input-number__increase,
  ::v-deep .el-input-number.is-controls-right .el-input-number__decrease {
    border-radius: 0;
  }
  ::v-deep .el-switch.is-checked .el-switch__core {
    border-color: #1677ff;
    background-color: #1677ff;
  }
  .image-uploader {
    .image-preview {
      position: relative;
      width: 120px;
      height: 120px;
      border-radius: 12px;
      overflow: hidden;
      cursor: pointer;
      border: 1px solid #e4e7ed;
      .el-image {
        width: 100%;
        height: 100%;
      }
      .image-mask {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0;
        transition: opacity 0.2s;
        i {
          font-size: 24px;
          color: #fff;
        }
      }
      &:hover .image-mask {
        opacity: 1;
      }
    }
    .upload-trigger {
      width: 120px;
      height: 120px;
      border-radius: 12px;
      border: 1px dashed #dcdfe6;
      background: #fafbfc;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all 0.2s;
      i {
        font-size: 32px;
        color: #8c8f98;
        margin-bottom: 8px;
      }
      span {
        font-size: 12px;
        color: #8c8f98;
      }
      &:hover {
        border-color: #1677ff;
        background: #f0f7ff;
        i, span { color: #1677ff; }
      }
    }
  }
  .form-actions {
    margin-top: 24px;
    text-align: center;
    ::v-deep .el-button {
      border-radius: 24px;
      padding: 8px 24px;
      margin: 0 8px;
    }
    ::v-deep .el-button--primary {
      background: #1677ff;
      border-color: #1677ff;
      &:hover { background: #4096ff; border-color: #4096ff; }
    }
  }
}
</style>